import { render } from "./charter-company.vue?vue&type=template&id=0a29bfee"
import script from "./charter-company.vue?vue&type=script&lang=js"
export * from "./charter-company.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__